// Todo: Add unique ID to each menu

export default class Default {
    /**
     * @param baseFactory
     * @returns {void}
     */
    constructor(baseFactory) {
        this.baseFactory = baseFactory;
        this.#init();
    }
    #init() {
        this.#onLoad();
        this.#onOutsideMenuClick();
        this.#onTopMenuClick();
        this.#onMenuExpandButtonClick();
        this.#onToggleBurgerMenuClick();
    }
    #onLoad() {
        this.#setBurgerMenuDefaultState();
    }
    #setBurgerMenuDefaultState() {
        const $verticalBars = jQuery('.stdw-hamburger-toggle .stdw-hamburger');
        if (jQuery('stdw-navbar').hasClass('stdw-hidden-mobile')) {
            $verticalBars.addClass('active');
        } else {
            $verticalBars.removeClass('active');
        }
    }
    #onToggleBurgerMenuClick() {
        jQuery('.stdw-hamburger-toggle').on('click', function() {
            const $verticalBars = jQuery(this).find('.stdw-hamburger');
            const $menu = jQuery('.stdw-navbar');
            if (!$verticalBars.hasClass('active')) {
                $verticalBars.addClass('active');
                $menu.removeClass('stdw-hidden-mobile');
            } else {
                $verticalBars.removeClass('active');
                $menu.addClass('stdw-hidden-mobile');
            }
        });
    }
    #onOutsideMenuClick() {
        const $ignoredElements = jQuery('.stdw-dropdown-menu, .stdw-nav-link');
        const $dropDownMenus = jQuery('.stdw-dropdown-menu');
        const $clickElementToTriggerHide = jQuery('body');
        $clickElementToTriggerHide.on('click', () => {
            $dropDownMenus.hide();
        });
        $ignoredElements.on('click', function(event){
            event.stopPropagation();
        });
    }
    #onTopMenuClick() {
        const $dropDownMenus = jQuery('.stdw-dropdown-menu');
        const self = this;
        jQuery('.stdw-nav-link.stdw-dropdown-toggle').on('click', function(e) {
            const $activeDropDownMenu = jQuery(this).next('ul');
            self.#hideNotActiveDropDownMenus($dropDownMenus, $activeDropDownMenu);
            e.preventDefault();
            $activeDropDownMenu.toggle(0, () => {
                if (!$activeDropDownMenu.hasClass('stdw-dropdown-submenu-right')) {
                    return;
                }
                self.#renameTopLevelMenuClassWhenOutsideRightViewport($activeDropDownMenu);
            });
        });
    }

    /**
     * @param {jQuery} $activeDropDownMenu
     */
    #renameTopLevelMenuClassWhenOutsideRightViewport($activeDropDownMenu) {
        if (this.#isElementOutsideRightViewport($activeDropDownMenu)) {
            $activeDropDownMenu.removeClass('stdw-dropdown-submenu-right');
            $activeDropDownMenu.addClass('stdw-dropdown-submenu-left');
        } else {
            $activeDropDownMenu.removeClass('stdw-dropdown-submenu-left');
            $activeDropDownMenu.addClass('stdw-dropdown-submenu-right');
        }
    }

    /**
     * @param {jQuery} $dropDownMenus
     * @param {jQuery} $activeDropDownMenu
     */
    #hideNotActiveDropDownMenus($dropDownMenus, $activeDropDownMenu) {
        $dropDownMenus.each(function() {
            const $dropDownMenu = jQuery(this);
            if (!$activeDropDownMenu.is($dropDownMenu)) {
                $dropDownMenu.hide();
            }
        });
    }
    #onMenuExpandButtonClick() {
        const self = this;
        jQuery('.stdw-toggle-expand').on('click', function(e) {
            e.preventDefault();

            const $expandButton = jQuery(this);
            const $expandButtons = jQuery(this).parent().parent().find('.stdw-toggle-expand.expanded');
            $expandButtons.each(function() {
                const $currentExpandButton = jQuery(this);
                if ($currentExpandButton.get(0) !== $expandButton.get(0)) {
                    $currentExpandButton.find('.stdw-minus-icon').hide();
                    $currentExpandButton.find('.stdw-plus-icon').show();
                    $currentExpandButton.prev('.stdw-dropdown-item').removeClass('is-expanded');
                    $currentExpandButton.removeClass('expanded')
                    $currentExpandButton.addClass('collapsed')
                }
            });

            const $subDropDownMenu = jQuery(this).next('.stdw-dropdown-menu');
            const $subDropDownMenus = $subDropDownMenu.parent().parent().find('.stdw-dropdown-menu.expanded');
            $subDropDownMenus.hide();
            $subDropDownMenus.removeClass('expanded')
            $subDropDownMenus.addClass('collapsed')

            if (!$expandButton.hasClass('expanded')) {
                $expandButton.find('.stdw-plus-icon').hide();
                $expandButton.find('.stdw-minus-icon').show();
                jQuery('.stdw-dropdown-item').removeClass('is-expanded');
                $expandButton.prev('.stdw-dropdown-item').addClass('is-expanded');
                $expandButton.addClass('expanded');
                $expandButton.removeClass('collapsed')

                $subDropDownMenu.show();
                $subDropDownMenu.removeClass('collapsed')
                $subDropDownMenu.addClass('expanded')

                $subDropDownMenu.removeClass('stdw-dropdown-submenu-left');
                $subDropDownMenu.addClass('stdw-dropdown-submenu-right');

                if (self.baseFactory.window().viewport().elementRightSiteOutOfViewport($subDropDownMenu.get(0))) {
                    $subDropDownMenu.removeClass('stdw-dropdown-submenu-right');
                    $subDropDownMenu.addClass('stdw-dropdown-submenu-left');
                }

            } else {
                $expandButton.find('.stdw-minus-icon').hide();
                $expandButton.find('.stdw-plus-icon').show();
                $expandButton.prev('.stdw-dropdown-item').removeClass('is-expanded');
                $expandButton.addClass('collapsed');
                $expandButton.removeClass('expanded')
                $expandButton.parent().parent().parent().find('>.stdw-dropdown-item').addClass('is-expanded');

                $subDropDownMenu.hide();
                $subDropDownMenu.removeClass('expanded')
                $subDropDownMenu.addClass('collapsed')

                $subDropDownMenu.removeClass('stdw-dropdown-submenu-left');
                $subDropDownMenu.removeClass('stdw-dropdown-submenu-right');
            }
        });
    }
    #isElementOutsideRightViewport($el)
    {
        let elementOffset = $el.offset();
        let elementWidth = $el.outerWidth();
        let windowWidth = jQuery(window).width();

        return (elementOffset.left + elementWidth > windowWidth);
    }
}
